import React from 'react';
import { Box, Typography } from '@mui/material';
import { Colors } from '../assets/theme/Colors';

const DonorLinkIcon = ({ size, isActive = true }) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '50%',
      color: Colors.white,
      cursor: 'default',
      containerType: 'size',
      bgcolor: isActive ? Colors.donorLink.color : Colors.lightGray,
    }}
    width={size}
    height={size}
  >
    <Typography sx={{ fontSize: '60cqw' }} variant="subtitle2">
      DL
    </Typography>
  </Box>
);

export default DonorLinkIcon;
